// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cc: CountryValidator<"PT"> = createValidator(
  "pt.cc",
  148,
);

export default cc;
export const compact = cc.compact;
export const format = cc.format;
export const validate = cc.validate;
export const generate = (): string =>
  cc.generate?.() ??
  (() => {
    throw new Error(
      "Validator pt.cc cannot generate values",
    );
  })();
